<template>
	<main class="vx-row">
		<div class="vx-col w-full">
			<vx-card>
				<div v-if="zakatCaption !== null" class="mt-4 mb-6">
					<h3 class="text-success"><strong>{{ zakatCaption }}</strong></h3>
				</div>

				<form>
					<span class="text-danger text-sm my-6" v-show="errors.has('capital')">{{ errors.first('capital') }}</span>
					<p class="mb-2"><strong>Modal 1 Tahun</strong></p>
					<vs-input
					    v-model="capital"
					    class="w-full mb-6"
					    size="large"
					    @keyup="toRupiahCapital()"
					    v-validate="'required'"
					    dir="rtl"
					    name="capital"
					/>

					<span class="text-danger text-sm my-6" v-show="errors.has('income')">{{ errors.first('income') }}</span>
					<p class="mb-2"><strong>Keuntungan 1 Tahun</strong></p>
					<vs-input
					    v-model="income"
					    class="w-full mb-6"
					    size="large"
					    @keyup="toRupiahIncome()"
					    v-validate="'required'"
					    dir="rtl"
					    name="income"
					/>

					<span class="text-danger text-sm my-6" v-show="errors.has('debt')">{{ errors.first('debt') }}</span>
					<p class="mb-2"><strong>Hutang / Kerugian 1 Tahun</strong></p>
					<vs-input
					    v-model="debt"
					    class="w-full mb-6"
					    size="large"
					    @keyup="toRupiahDebt()"
					    v-validate="'required'"
					    dir="rtl"
					    name="debt"
					/>

					<span class="text-danger text-sm my-6" v-show="errors.has('debt_due')">{{ errors.first('debt_due') }}</span>
					<p class="mb-2"><strong>Hutang Jatuh Tempo</strong></p>
					<vs-input
					    v-model="debt_due"
					    class="w-full mb-6"
					    size="large"
					    @keyup="toRupiahDebtDue()"
					    v-validate="'required'"
					    dir="rtl"
					    name="debt_due"
					/>

					<span class="text-danger text-sm my-6" v-show="errors.has('account_receivable')">{{ errors.first('account_receivable') }}</span>
					<p class="mb-2"><strong>Piutang Dagang</strong></p>
					<vs-input
					    v-model="account_receivable"
					    class="w-full mb-6"
					    size="large"
					    @keyup="toRupiahAccountReceivable()"
					    v-validate="'required'"
					    dir="rtl"
					    name="account_receivable"
					/>
					<br>
					<vs-button
					    color="primary"
					    size="large"
					    class="w-full mb-4"
					    @click.prevent="calculateZakat"
					>
					Hitung Zakat
					</vs-button>
					<vs-button
					    color="warning"
					    size="large"
					    type="gradient"
					    class="w-full mb-4"
					    @click.prevent="payZakat"
					>
					<span class="text-dark">Bayar {{ capitalize(type) }}</span>
					</vs-button>	
				</form>
			</vx-card>
		</div>
	</main>
</template>
<script type="text/javascript">
import { Validator } from 'vee-validate'
import { minNishabZakat, goldPrice } from '@/assets/utils/zakat'

const dict = {
  custom: {
    capital: {
      required: 'Harap masukan modal dagang anda'
    },
    income: {
      required: 'Harap masukan keuntungan dagang anda'
    },
    debt: {
      required: 'Harap masukan hutang dagang anda'	
    },
    debt_due: {
      required: 'Harap masukan hutang jatuh tempo dagang anda'	
    },
    account_receivable: {
      required: 'Harap masukan piutang dagang anda'	
    }
  }
}

Validator.localize('en', dict)

export default {
  data: () => ({
    type: 'zakat',
    zakatCaption: null,
    capital: 0,
    income: 0,
    debt: 0,
    zakat: 0,
    debt_due: 0,
    account_receivable: 0
  }),
  methods: {
    toRupiahCapital () {
      this.capital = this.formatRupiah(this.capital)
    },
    toRupiahIncome () {
      this.income = this.formatRupiah(this.income)
    },
    toRupiahDebt () {
      this.debt = this.formatRupiah(this.debt)
    },
    toRupiahDebtDue () {
      this.debt_due = this.formatRupiah(this.debt_due)
    },
    toRupiahAccountReceivable () {
      this.account_receivable = this.formatRupiah(this.account_receivable)
    },
    calculateZakat () {
      this.$validator.validateAll().then(res => {
        if (res) {
          const capital = parseInt(this.capital.toString().replace(/[^0-9-,]/g, '')),
            income = parseInt(this.income.toString().replace(/[^0-9-,]/g, '')),
            debt = parseInt(this.debt.toString().replace(/[^0-9-,]/g, '')),
            debt_due = parseInt(this.debt_due.toString().replace(/[^0-9-,]/g, '')),
            account_receivable = parseInt(this.account_receivable.toString().replace(/[^0-9-,]/g, '')),
            myGoldPrice = 85 * goldPrice,
            numDebt = debt + debt_due,
            numIncome = capital + income + account_receivable,
            finalResult = Math.ceil(minNishabZakat * (numIncome - numDebt))

          if ((numIncome - numDebt) < myGoldPrice) {
            this.zakat = finalResult
            this.zakatCaption = 'Anda belum wajib mengeluarkan zakat perdagangan'
            this.type = 'infaq'
          } else {
            this.zakat = finalResult
            this.type = 'zakat'
            this.zakatCaption = `Hasil perhitungan zakat anda Rp ${ this.formatRupiah(finalResult) }`	
          }
        }
      })
    },
    payZakat () {
      this.$emit('payZakat', {total: this.zakat, type: this.type})
    }
  }
}
</script>